<template>
  <div class="container">
    <div class="col-lg-4 col-md-6 ml-auto mr-auto">
      <div v-if="login">
        <card class="card-login card-white text-left">
          <div>
            <h2 class="text-center">Login</h2>
            <base-input
              name="email"
              v-model="user.email"
              placeholder="Username"
              addon-left-icon="tim-icons icon-email-85"
            >
            </base-input>

            <base-input
              name="password"
              v-model="user.password"
              type="password"
              placeholder="Password"
              addon-left-icon="tim-icons icon-lock-circle"
            >
            </base-input>
          </div>

          <div slot="footer">
            <base-button
              native-type="submit"
              type="primary"
              class="mb-3"
              size="lg"
              block
              @click="autenticar"
            >
              Entrar
            </base-button>

            <!-- <div class="pull-left">
              <h6>
                <p class="link footer-link pointer" @click="login = false">
                  Registar
                </p>
              </h6>
            </div> -->
          </div>
        </card>
      </div>
      <div v-else>
        <card class="card-login card-white text-left">
          <h2 class="text-center">Registar</h2>
          <div>
            <base-input
              name="email"
              v-model="registo.email"
              placeholder="Email"
              addon-left-icon="tim-icons icon-email-85"
            >
            </base-input>
            <base-input
              name="nome"
              v-model="registo.nome"
              placeholder="Nome do restaurante"
              addon-left-icon="tim-icons icon-email-85"
            >
            </base-input>
            <base-input
              name="Telefone"
              v-model="registo.telefone"
              placeholder="Telefone"
              addon-left-icon="tim-icons icon-email-85"
            >
            </base-input>
            <base-input
              name="morada"
              v-model="registo.morada"
              placeholder="Morada"
              addon-left-icon="tim-icons icon-email-85"
            >
            </base-input>

            <base-input
              name="password"
              v-model="registo.password"
              type="password"
              placeholder="Password"
              addon-left-icon="tim-icons icon-lock-circle"
            >
            </base-input>
          </div>

          <div slot="footer">
            <base-button
              native-type="submit"
              type="primary"
              class="mb-3"
              size="lg"
              block
              @click="registar"
            >
              Registar
            </base-button>
            <div class="pull-left">
              <h6>
                <p class="link footer-link pointer" @click="login = true">
                  Entrar
                </p>
              </h6>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { Card, BaseInput } from "@/components/index";
import api from "../../api";
export default {
  components: {
    Card,
    BaseInput,
  },
  data() {
    return {
      login: true,
      user: {
        email: "",
        password: "",
      },
      registo: {
        email: "",
        morada: "",
        nome: "",
        telefone: "",
        password: "",
      },
    };
  },
  methods: {
    async registar() {
      if (!this.validateEmail(this.registo.email.trim())) {
        this.notifyVue("top", "right", "warning", "O seu email não é válido");
        return;
      }
      if (!this.validatePhone(this.registo.telefone.trim())) {
        this.notifyVue(
          "top",
          "right",
          "warning",
          "O seu nº de telefone não é válido"
        );
        return;
      }
      if (
        this.registo.nome.trim() == "" ||
        this.registo.password.trim() == "" ||
        this.registo.morada.trim() == ""
      ) {
        this.notifyVue(
          "top",
          "right",
          "warning",
          "Tem de preencher todos os campos"
        );
        return;
      }

      let res = await api.registar(this.registo);

      if (res.resultado != "OK") {
        this.notifyVue(
          "top",
          "right",
          "warning",
          "As suas credenciais não foram encontradas."
        );
      } else {
        this.notifyVue(
          "top",
          "right",
          "success",
          "O seu registo foi concluído."
        );
        this.login = true;
        this.user.email = this.registo.email;
      }
    },

    async autenticar() {
      var json = {
        email: this.user.email,
        password: this.user.password,
      };
      let res = await api.loginMaster(json);
      console.log(res);
      if (res.resultado != "OK") {
        this.notifyVue(
          "top",
          "right",
          "warning",
          "As suas credenciais não foram encontradas."
        );
      } else {
        var user = JSON.stringify(res.data);
        localStorage.setItem("appGerenciaLogin", user);
        this.$router.push("Dashboard");
      }
    },

    validatePhone(phoneNumber) {
      const regex = /^(2\d{8}|9[1236]\d{7})$/;

      return regex.test(phoneNumber);
    },

    notifyVue(verticalAlign, horizontalAlign, color, mensagem) {
      this.$notify({
        icon: "tim-icons icon-bell-55",
        message: mensagem,
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: color,
        timeout: 2000,
      });
    },

    validateEmail(email) {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      return regex.test(email);
    },
  },
  async mounted() {},
};
</script>
<style>
.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}
</style>
